import { render, staticRenderFns } from "./TvaVideoLazy.vue?vue&type=template&id=569c61f7&scoped=true&"
import script from "./TvaVideoLazy.vue?vue&type=script&lang=js&"
export * from "./TvaVideoLazy.vue?vue&type=script&lang=js&"
import style0 from "./TvaVideoLazy.vue?vue&type=style&index=0&id=569c61f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569c61f7",
  null
  
)

export default component.exports